module.exports = __webpack_public_path__ + "static/media/icon-leads-small.175c11b8.svg";